import { useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import { useDispatch, useSelector } from 'react-redux'

const EndClassModal = () => {
  const dispatch = useDispatch()

  const isOpen = true

  const handleClose = () => {}

  useEffect(() => {
    return () => {
      handleClose()
    }
  }, [])

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FEEBDD] !shadow-modal',
      }}
    >
      <div className="w-full flex flex-col items-center ">
        <div className="text-xl font-bold text-[#F67443] text-center mb-1">
          Are you sure you want to end the class?
        </div>
        <p className="text-base  text-[#F67443] text-center my-2">
          he class is still running, and you may miss important information or updates from your
          tutor.
        </p>
        <p className="text-base  text-[#F67443] text-center my-2">
          If you choose to end the class, your recorded session will be saved up to this point, and
          you can access it later.
        </p>
        <button
          className="mt-[24px] w-full h-[44px] rounded-lg flex items-center justify-center  text-lg font-semibold text-white bg-[#F79009] "
          onClick={handleClose}
        >
          Confirm End Lesson
        </button>
        <button
          className="mt-[24px] w-full h-[44px] rounded-lg border border-solid border-color-[#F79009] flex items-center justify-center  text-lg font-semibold text-[#F79009]"
          onClick={handleClose}
        >
          Cancel
        </button>
      </div>
    </Dialog>
  )
}

export default EndClassModal
